import { render, staticRenderFns } from "./securitySettings.vue?vue&type=template&id=b01d5296&scoped=true"
import script from "./securitySettings.vue?vue&type=script&lang=js"
export * from "./securitySettings.vue?vue&type=script&lang=js"
import style0 from "./securitySettings.vue?vue&type=style&index=0&id=b01d5296&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01d5296",
  null
  
)

export default component.exports